import * as Yup from "yup";
import {
  ProjectInitialValue,
  ProjectListData,
  UserInitialValue,
  AuthorInitialValue,
} from "../../../Types/Application/ProjectList/ProjectList";

export const projectData: ProjectListData[] = [
  {
    id: 1,
    title: "Endless admin Design",
    badge: "Doing",
    image: "3.jpg",
    sites: "Themeforest, australia",
    description:
      "Endless Admin is a full featured, multipurpose, premium bootstrap admin template.",
    issue: "12",
    resolved: "5",
    comment: "7",
    like: "10",
    progress: 70,
    customers_image1: "3.jpg",
    customers_image2: "5.jpg",
    customers_image3: "1.jpg",
    color: "primary",
  },
  {
    id: 2,
    title: "Universal admin Design",
    badge: "Done",
    image: "3.jpg",
    sites: "Themeforest, australia",
    description:
      "Universal Admin is a full featured, multipurpose, premium bootstrap admin template.",
    issue: "24",
    resolved: "24",
    comment: "40",
    like: "3",
    progress: 100,
    customers_image1: "3.jpg",
    customers_image2: "5.jpg",
    customers_image3: "1.jpg",
    color: "secondary",
  },
  {
    id: 3,
    title: "Poco admin Design",
    badge: "Done",
    image: "3.jpg",
    sites: "Themeforest, australia",
    description:
      "Poco Admin is a full featured, multipurpose, premium bootstrap admin template.",
    issue: "40",
    resolved: "40",
    comment: "20",
    like: "2",
    progress: 100,
    customers_image1: "3.jpg",
    customers_image2: "5.jpg",
    customers_image3: "1.jpg",
    color: "success",
  },
  {
    id: 4,
    title: "Universal admin Design",
    badge: "Done",
    image: "3.jpg",
    sites: "Themeforest, australia",
    description:
      "Universal Admin is a full featured, multipurpose, premium bootstrap admin template.",
    issue: "24",
    resolved: "24",
    comment: "40",
    like: "3",
    progress: 100,
    customers_image1: "3.jpg",
    customers_image2: "5.jpg",
    customers_image3: "1.jpg",
    color: "primary",
  },
  {
    id: 5,
    title: "Endless admin Design",
    badge: "Doing",
    image: "3.jpg",
    sites: "Themeforest, australia",
    description:
      "Endless Admin is a full featured, multipurpose, premium bootstrap admin template.",
    issue: "12",
    resolved: "5",
    comment: "7",
    like: "10",
    progress: 70,
    customers_image1: "3.jpg",
    customers_image2: "5.jpg",
    customers_image3: "1.jpg",
    color: "secondary",
  },
  {
    id: 6,
    title: "Poco admin Design",
    badge: "Done",
    image: "3.jpg",
    sites: "Themeforest, australia",
    description:
      "Poco Admin is a full featured, multipurpose, premium bootstrap admin template.",
    issue: "40",
    resolved: "40",
    comment: "20",
    like: "2",
    progress: 100,
    customers_image1: "3.jpg",
    customers_image2: "5.jpg",
    customers_image3: "1.jpg",
    color: "success",
  },
];

export const projectInitialValue: ProjectInitialValue = {
  title: "",
  client: "",
  progress: 0,
  type: "",
  priority: "",
  size: "",
  description: "",
};
export const userInitialValue: UserInitialValue = {
  name: "",
  email: "",
  password: "",
  username: "",
};
export const authorInitialValue: AuthorInitialValue = {
  name: "",
  bio: "",
  image: undefined as any, // 👈 important: must not be empty string!
};

export const userValidation = Yup.object().shape({
  name: Yup.string().required("Name is required"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\W]).+$/,
      "Password must include at least one lowercase, one uppercase letter, and one number or special character"
    )
    .required("New password is required"),

  username: Yup.string()
    .matches(
      /^[a-zA-Z][a-zA-Z0-9._]{5,29}$/,
      "Username must start with a letter and can contain letters, numbers, dots, and underscores (6–30 characters)."
    )
    .required("Username is required"),
});
export const userEditValidation = Yup.object().shape({
  name: Yup.string().required("Name is required"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\W]).+$/,
      "Password must include at least one lowercase, one uppercase letter, and one number or special character"
    )
    .optional(),

  username: Yup.string()
    .matches(
      /^[a-zA-Z][a-zA-Z0-9._]{5,29}$/,
      "Username must start with a letter and can contain letters, numbers, dots, and underscores (6–30 characters)."
    )
    .required("Username is required"),
});
export const profileValidation = Yup.object().shape({
  name: Yup.string().required("Name is required"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  password: Yup.string()
    .optional()
    .min(6, "Password must be at least 6 characters"),

  username: Yup.string()
    .matches(
      /^[a-zA-Z][a-zA-Z0-9._]{5,29}$/,
      "Username must start with a letter and can contain letters, numbers, dots, and underscores (6–30 characters)."
    )
    .required("Username is required"),
});
export const authorValidation = Yup.object().shape({
  name: Yup.string().required("Name is required"),

  bio: Yup.string()
    .min(10, "Bio must be at least 10 characters")
    .required("Bio is required"),

  image: Yup.mixed()
    .nullable()
    .test("fileType", "Unsupported file format", function (value) {
      const { pictureUrl } = this.parent;

      // If no new file and there’s already an existing image, allow it
      if (!value && pictureUrl) return true;

      // If no file at all and no existing image, fail
      if (!value) return this.createError({ message: "Image is required" });

      const file = value as File;
      return ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(
        file.type
      );
    })
    .test("fileSize", "File size must not exceed 10MB", function (value) {
      const { pictureUrl } = this.parent;

      // If no new file and there’s already an existing image, allow it
      if (!value && pictureUrl) return true;

      // If no file at all and no existing image, fail
      if (!value) return this.createError({ message: "Image is required" });

      const file = value as File;
      return file.size <= 10 * 1024 * 1024; // 10 MB
    }),
});
export const authorEditValidation = Yup.object().shape({
  name: Yup.string().required("Name is required"),

  bio: Yup.string()
    .min(10, "Bio must be at least 10 characters")
    .required("Bio is required"),

  image: Yup.mixed()
    .nullable()
    .test("fileType", "Unsupported file format", function (value) {
      const { pictureUrl } = this.parent; // 👈 Access existing image

      // If no new file but an existing image URL exists, it's valid
      if (!value && pictureUrl) return true;

      // If no value at all and no existing image, fail
      if (!value) return this.createError({ message: "Image is required" });

      // If value is a File, check its type
      const file = value as File;
      return ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(
        file.type
      );
    })
    .test("fileSize", "File size must not exceed 10MB", function (value) {
      const { pictureUrl } = this.parent;

      // If no new file and there’s already an existing image, allow it
      if (!value && pictureUrl) return true;

      // If no file at all and no existing image, fail
      if (!value) return this.createError({ message: "Image is required" });

      const file = value as File;
      return file.size <= 10 * 1024 * 1024; // 10 MB
    }),
});
export const projectValidation = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  client: Yup.string().required("Client Name is required"),
  description: Yup.string().required("Some Details is required"),
  progress: Yup.number().required("Between 0 to 100").max(100),
});
